module.exports = __webpack_public_path__ + "img/seal.0b3faa19.png";